import { SVGProps, Ref, forwardRef } from 'react';

export const PinFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M9.336 14.327q-.12.145-.256.28l-.721.723-3.348-3.348L1.5 15.5l-1-1 3.521-3.508L.667 7.637l.722-.722a4.08 4.08 0 0 1 3.46-1.152l1.346.192 3.267-3.267L8.26 1.486l.99-.99 6.25 6.25-.99.99-1.202-1.202-3.267 3.267.193 1.346a4.08 4.08 0 0 1-.898 3.18"
            fill="currentColor"
        />
    </svg>
));
PinFilledSize16Glyph.displayName = 'PinFilledSize16Glyph';
